import MyDevices from './MyDevices';

export default MyDevices;
